module.exports = __webpack_public_path__ + "static/media/hajj-package-2.bf3f77aa.jpg";